import { render, staticRenderFns } from "./CustomerPartnerList.vue?vue&type=template&id=47d81cf0&scoped=true"
import script from "./CustomerPartnerList.vue?vue&type=script&lang=js"
export * from "./CustomerPartnerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerPartnerList.vue?vue&type=style&index=0&id=47d81cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d81cf0",
  null
  
)

export default component.exports